// @core/api/endpoints/fiscalization/get_fiscal_policy_by_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FiscalPolicyResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Get entity fiscal policy
 * Returns the fiscal policy directly attached to the specified entity. Does NOT resolve inheritance.
 */
export async function GetFiscalPolicyByEntity(
  entity_type: string,
  entity_id: string,
  options?: RequestOptions
): Promise<FiscalPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/fiscal/:entity_type/:entity_id/policy`;
  requestPath = requestPath.replace(':entity_type', encodeURIComponent(entity_type));
  requestPath = requestPath.replace(':entity_id', encodeURIComponent(entity_id));
  const requestOptions = options;
  return client.get<FiscalPolicyResponse>(requestPath, { ...requestOptions });
}
